import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ConfigurationModel } from '../+state/common.models';
import { ConfigService } from './config.service';

@Injectable({
  providedIn: 'root',
})
export class UserService {
  configuration: ConfigurationModel;

  constructor(
    private httpClient: HttpClient,
    private configService: ConfigService
  ) {
    this.configService.getConfig().subscribe((x) => {
      this.configuration = x.config;
    });
  }

  loadUserEntitlements(): Observable<string[]> {
    return this.httpClient.get<string[]>(
      `${this.configuration.apiUrl}/user/entitlements`
    );
  }
}
